// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16F9v","question":"styles_question__19a-J","description":"styles_description__1vJVA"};